import { render, staticRenderFns } from "./tableTheFirstTop10Shareholders.vue?vue&type=template&id=53a5e0c1&scoped=true"
import script from "./tableTheFirstTop10Shareholders.vue?vue&type=script&lang=js"
export * from "./tableTheFirstTop10Shareholders.vue?vue&type=script&lang=js"
import style0 from "./tableTheFirstTop10Shareholders.vue?vue&type=style&index=0&id=53a5e0c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5e0c1",
  null
  
)

export default component.exports